export default __webpack_public_path__ + "static/MeshMap-b3e0c09f0fcdbd528f8cc38bf72717f6.png";